import React, { useRef, useLayoutEffect } from "react";
import { Wrapper } from "./index.styled";
import FullScreenCopy from "components/fullscreen-copy";
import Info from "./info";
import Pagination from "components/pagination";
import CompaniesList from "./comapnies-list";
import { gsap, ScrollTrigger } from "helpers/gsap";

const Sustainability = ({ data }) => {
  const refWrapper = useRef(null);

  useLayoutEffect(() => {
    let gsapContext = gsap.context(() => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".building-image",
            start: "top center",
            end: "bottom bottom",
            toggleActions: "play none none reverse",
          },
        })
        .from(".building-image", {
          duration: 1,
          opacity: 0,
          y: 25,
        });

      const list = Array.from(document.querySelectorAll(".company-item"));

      list.forEach((item, index) => {
        const tl = gsap.timeline().from(
          item,
          {
            yPercent: "20",
            opacity: 0,
            duration: 1,
          },
          0
        );
        ScrollTrigger.create({
          trigger: item,

          start: "top center+=30%",
          animation: tl,
          toggleActions: "play none none reverse",
        });
      });
    }, refWrapper);

    return () => gsapContext.revert();
  }, []);

  return (
    <Wrapper ref={refWrapper}>
      {data?.map((section, index) => {
        if (section.type === "fullscreenCopy") {
          return (
            
              <FullScreenCopy
                data={section}
                key={`residences-section-${index}`}
              />
            
          );
        } else if (section.type === "info") {
          return <Info data={section} key={`residences-section-${index}`} />;
        } else if (section.type === "companies") {
          return (
            <CompaniesList data={section} key={`service-section-${index}`} />
          );
        } else if (section.type === "pagination") {
          return <Pagination data={section} key={`service-section-${index}`} />;
        }
      })}
    </Wrapper>
  );
};

export default Sustainability;
